export enum PaymentStatus {
  Process,
  Success,
  Failed
}
